import React, { useState } from "react";
import "./Register.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { registerUser } from "../../Redux/Slices/Utility/RegisterSlice";
import { useForm } from "react-hook-form";
import { AlertPopup } from "../../Asset/common";
import registerlogo from '../../../src/Website/images/DiamondSyncWhite.png'
import { isValidPhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js';
import validator from 'email-validator';

function Register() {
  const navigate = useNavigate();
  const [arr, setarr] = useState(
    JSON.parse(localStorage?.getItem("users")) || []
  );

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();

  const isAdmin = true;

  const onSubmit = async (data) => {
    if (
      Object.values(data).every(
        (val) => typeof val === "string" && val.trim() !== ""
      )
    ) {

      debugger
      if (data.Password !== data.ConfirmPassword) {
        AlertPopup.warningPopup("Password does not match with confirm password !!");
        return;
      }

      try {

        // console.log('RegUserdata',data);
        debugger

        const success = await dispatch(registerUser(data));
        if (success) {
          navigate("/login"); // Navigate only if registration succeeded
        }
      } catch (error) {
        console.error("Error registering user:", error);
        AlertPopup.warningPopup("An error occurred while registering. Please try again later.");
      }
    } else {
      AlertPopup.warningPopup("Please fill in all the required fields !!");
    }
  };

  return (
    <>
      <div className="ocean">
        <div className="wave"></div>
        <div className="wave"></div>
      </div>
      <section>
        <div className="Regcontainer" id="container">
          <div className="form-container sign-in-container" >

            <div className="row mt-2 w-100">
              <form onSubmit={handleSubmit(onSubmit)} className="row">
                <h5 className="py-2">Register with us</h5>
                <div className="col">
                  <div className="row">
                    <div className="col-12 col-lg-6 col-sm-6 col-md-6 p-1">
                      <input
                        type="Text"
                        placeholder="FirstName"
                        className="form-control"
                        name="FirstName"
                        {...register("FirstName", {
                          required: "This field is required",
                        })}
                      />
                      {errors.FirstName && (
                        <span className="validation">
                          {errors.FirstName.message}
                        </span>
                      )}
                    </div>
                    <div className="col-12 col-lg-6 col-sm-6 col-md-6 p-1">
                      <input
                        type="Text"
                        placeholder="LastName"
                        className="form-control "
                        name="LastName"
                        {...register("LastName", {
                          required: "This field is required",
                        })}
                      />
                      {errors.LastName && (
                        <span className="validation">
                          {errors.LastName.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12 col-lg-6  col-sm-6 col-md-6 p-1">
                      <input
                        type="Text"
                        placeholder="Username"
                        className="form-control "
                        name="Username"
                        {...register("Username", {
                          required: "This field is required",
                        })}
                      />
                      {errors.Username && (
                        <span className="validation">
                          {errors.Username.message}
                        </span>
                      )}
                    </div>
                    <div className="col-12 col-lg-6 col-sm-6 col-md-6 p-1">
                      <input
                        type="Text"
                        placeholder="PhoneNumber"
                        className="form-control "
                        name="PhoneNumber"
                        {...register("PhoneNumber", {
                          required: "This field is required",
                          validate: (value) => {
                            const phone = parsePhoneNumberFromString(value, "IN"); // IN = India
                            if (!phone || !phone.isValid()) {
                              return "Enter a valid phone number";
                            }
                            return true;
                          }
                        })}
                      />
                      {errors.PhoneNumber && (
                        <span className="validation">
                          {errors.PhoneNumber.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12 col-lg-6 col-sm-6 p-1">
                      <input
                        type="Text"
                        placeholder="Email"
                        className="form-control"
                        name="Email"
                        {...register("Email", {
                          required: "This field is required",
                          pattern: {
                            value: /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/,
                            message: "Invalid email address",
                          },
                          validate: (value) => {
                            if (!validator.validate(value)) {
                              return "Please enter a valid email address";
                            }

                            // Optional: basic fake check
                            if (/^(test|abc|demo)/i.test(value) || value.includes("example.com")) {
                              return "Avoid using fake or temporary emails";
                            }

                            return true;
                          }
                        })}
                      />
                      {errors.Email && (
                        <span className="validation">{errors.Email.message}</span>
                      )}
                    </div>
                    <div className="col-12 col-lg-6 col-sm-6 col-md-6 p-1">
                      <input
                        type="Text"
                        placeholder="Website"
                        className="form-control "
                        name="Website"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12 col-lg-6 col-sm-6 col-md-6 p-1">
                      <input
                        type="Text"
                        placeholder="Company Name"
                        className="form-control "
                        name="CompanyName"
                        {...register("CompanyName", {
                          required: "This field is required",
                        })}
                      />
                      {errors.CompanyName && (
                        <span className="validation">
                          {errors.CompanyName.message}
                        </span>
                      )}
                    </div>
                    <div className="col-12 col-lg-6 col-sm-6 col-md-6 p-1">
                      <input
                        type="Text"
                        placeholder="Designation"
                        className="form-control "
                        name="Designation"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12 col-lg-6 col-sm-6 col-md-6 p-1">
                      <input
                        type="Text"
                        placeholder="Address 1"
                        className="form-control "
                        name="AddressLine1"
                        {...register("AddressLine1", {
                          required: "This field is required",
                        })}
                      />
                      {errors.AddressLine1 && (
                        <span className="validation">
                          {errors.AddressLine1.message}
                        </span>
                      )}
                    </div>
                    <div className="col-12 col-lg-6 col-sm-6 col-md-6 p-1">
                      <input
                        type="Text"
                        placeholder="Address 2"
                        className="form-control "
                        name="AddressLine2"
                        {...register("AddressLine2", {
                          required: "This field is required",
                        })}
                      />
                      {errors.AddressLine2 && (
                        <span className="validation">
                          {errors.AddressLine2.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-6 col-lg-3 col-sm-6 col-md-6 p-1">
                      <input
                        type="Text"
                        placeholder="Country"
                        className="form-control "
                        name="Country"
                        {...register("Country", {
                          required: "This field is required",
                        })}
                      />
                      {errors.Country && (
                        <span className="validation">
                          {errors.Country.message}
                        </span>
                      )}
                    </div>

                    <div className="col-6 col-lg-3 col-sm-6 col-md-6 p-1">
                      <input
                        type="Text"
                        placeholder="StateRegion"
                        className="form-control "
                        name="StateRegion"
                        {...register("StateRegion", {
                          required: "This field is required",
                        })}
                      />
                      {errors.StateRegion && (
                        <span className="validation">
                          {errors.StateRegion.message}
                        </span>
                      )}
                    </div>
                    <div className="col-6 col-lg-3 col-sm-6 col-md-6 p-1">
                      <input
                        type="Text"
                        placeholder="City"
                        className="form-control "
                        name="City"
                        {...register("City", {
                          required: "This field is required",
                        })}
                      />
                      {errors.City && (
                        <span className="validation">
                          {errors.City.message}
                        </span>
                      )}
                    </div>
                    <div className="col-6 col-lg-3 col-sm-6 col-md-6 p-1">
                      <input
                        type="Text"
                        placeholder="Pincode"
                        className="form-control "
                        name="Pincode"
                        {...register("Pincode", {
                          required: "This field is required",
                        })}
                      />
                      {errors.Pincode && (
                        <span className="validation">
                          {errors.Pincode.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12 col-lg-6 col-sm-6 col-md-6 p-1">
                      <input
                        type="password"
                        placeholder="Password"
                        className="form-control "
                        name="Password"
                        {...register("Password", {
                          required: "This field is required",
                          pattern: {
                            value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/,
                            message: "Password must contain at least one digit, one lowercase letter, one uppercase letter, and be at least 8 characters long",
                          },
                        })}
                      />
                      {errors.Password && (
                        <span className="validation">
                          {errors.Password.message}
                        </span>
                      )}
                    </div>
                    <div className="col-12 col-lg-6 col-sm-6 col-md-6 p-1">
                      <input
                        type="password"
                        placeholder="Confirm Password"
                        className="form-control "
                        name="ConfirmPassword"
                        {...register("ConfirmPassword", {
                          required: "This field is required",
                          pattern: {
                            value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/,
                            message: "Password must contain at least one digit, one lowercase letter, one uppercase letter, and be at least 8 characters long",
                          },
                        })}
                      />
                      {errors.Password && (
                        <span className="validation">
                          {errors.Password.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className=" py-3">
                    <button className="savepanelBtn w-25 btn-primary ml-md-2">
                      Sign Up
                    </button>
                  </div>
                </div>

                <div className="foottext">
                  <span>
                    Already have an account?
                  </span>
                  <Link
                    to="/Login"
                    style={{
                      color: "#337357",
                      fontWeight: "700",
                      float: "right",
                      margin: "-5px 5px",
                    }}
                  >
                    Login
                  </Link>
                </div>
                <div className="col-sm-6 col-md-6 text-light overlay-container">
                  <img src={registerlogo} alt="" className="w-75 img-fluid" />
                  <h1>Create, Account!</h1>
                  <p>Sign up if you still don't have an account ... </p>
                </div>
              </form>

            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default Register;
